import { createContext, useContext } from "react";

export const OrganizationPlanContext = createContext(null);

export function useStarterPlan() {
  return useContext(OrganizationPlanContext) === true;
}
